define('views/blocks/EdenredSwitchView',['underscore', 'backbone', 'app', 'SubView',
        'BtnSwitchView',
        'models/EdenredDataModel',
        'views/blocks/checkout/PaymentModeSelectionModalView',
        'template!blocks/payments/edenred-switch'
    ],
    function (_, Backbone, app, SubView,
              BtnSwitchView,
              EdenredDataModel,
              PaymentModeSelectionModalView,
              edenredSwitchTemplate) {

        var view, checkoutModel;

        var EdenredSwitchView = Backbone.View.extend(SubView).extend({
            //
            className: '',
            //
            events:{
                'click .login-edenred':'clickLoginEdenred',
                'change #edenred_switch':'onSwitch'
            },
            initialize: function (options) {

                view = this;
                view.subviews = [];
                checkoutModel = options.checkoutModel;
                view.listenTo(EdenredDataModel,'change:status change:auth change:sync',view.onStatusChange);
                view.listenTo(app,'requireDisableEdenred',view.uncheck);
                view.render();
            },
            render: function () {
                view.$el.html(edenredSwitchTemplate({
                    edenred:EdenredDataModel
                }));
                var btnSwitchEl = view.$('.btn-switch').get(0), btnSwitchView;
                if(btnSwitchEl){
                    btnSwitchView = new BtnSwitchView({el:btnSwitchEl,checked:EdenredDataModel.get('checked')});
                    view.listenTo(btnSwitchView,'change',view.changeChecked);
                    view.attachView(btnSwitchView);
                }
                view.delegateEvents();

            },
            clickLoginEdenred:function(){
                app.displayModal(new PaymentModeSelectionModalView({
                    checkoutModel: checkoutModel,
                    group:1
                }));
            },
            uncheck:function(){
                this.$('#edenred_switch').prop('checked',false);
            },
            changeChecked:function(checked){
                EdenredDataModel.set('checked',checked=='yes');
            },
            onStatusChange:function(){
                this.render();
            },
            onSwitch:function(e){
                var checked = e.currentTarget.checked;
                EdenredDataModel.set('checked',checked);
            }
        });

        return EdenredSwitchView;
    });

